import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import useTypedFlags from "hooks/useTypedFlags";
import { AccountContext } from "views/AccountWrapper";
import { Blueprint } from "types/generated";
import { hasSpaceManageAccess } from "utils/user";
import { AccessResult, hasManageAccess, NO_ACCESS_MESSAGE } from "utils/access";

const useCanManageBlueprint = (): ((blueprint?: Blueprint) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);
  const { customAccessRoles } = useTypedFlags();

  return useCallback(
    (blueprint?: Blueprint) => {
      if (!blueprint) {
        return { result: false };
      }

      if (blueprint.deleted) {
        return { result: false };
      }

      if (viewer.admin) {
        return { result: true };
      }

      const result = customAccessRoles
        ? hasManageAccess(viewer, blueprint.space.id)
        : hasSpaceManageAccess(blueprint.space.accessLevel);

      if (result) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [customAccessRoles, viewer]
  );
};

export default useCanManageBlueprint;
